import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, setAuthToken } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { AuraMark } from "@/components/AuraMark";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || "";
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { navigate("/login"); return; }
    (async () => {
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        if (res.data.session_token) setAuthToken(res.data.session_token);
        setUser(res.data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { state: { user: res.data.user } });
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--aura-bg)] gap-6">
      <AuraMark className="w-14 h-14 floaty" />
      <div className="flex items-end gap-1 h-10" aria-hidden="true">
        {[0,1,2,3,4].map((i) => (
          <span key={i} className="eq-bar w-1.5 bg-cyan-400 rounded-full" style={{ animationDelay: `${i*0.12}s`, height: "40%" }} />
        ))}
      </div>
      <p className="label-mono text-slate-400">Tuning your session…</p>
    </div>
  );
}
